
































































import Vue from 'vue';
import { Type } from 'expangine-runtime';
import { LiveRuntime } from 'expangine-runtime-live';
import { TypeSettings, TypeUpdateEvent } from '../runtime/types/TypeVisuals';
import { sendNotification } from './Notify';
import { Registry } from '../runtime/Registry';


export default Vue.extend({
  props: {
    registry: {
      type: Object as () => Registry,
      required: true,
    },
    labelDetect: {
      type: String,
      default: 'Detect',
    },
    labelLoad: {
      type: String,
      default: 'Load',
    },
    hideRemoveRestrictions: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    type: null as null | Type,
    settings: null as null | TypeSettings,
    input: '',
    data: null as any,
    removeDescribedRestrictions: true,
    tab: 0,
  }),
  computed: {
    isRemoveRestrictions() {
      return this.removeDescribedRestrictions || this.hideRemoveRestrictions;
    },
    canDetect(): boolean {
      return !!this.input;
    },
    canLoad(): boolean {
      return !!(this.input && this.type);
    },
    dataType(): Type | null {
      if (!this.type || !this.removeDescribedRestrictions) {
        return this.type;
      }
      const removed = this.type.clone();
      removed.removeDescribedRestrictions();
      return removed;
    },
  }, 
  methods: {
    determineType() {
      const firstVarRegex = /(var\s+|const\s+|let\s+|)([$a-z_][$a-z_0-9]*)\s*=/gi;
      const firstVarMatch = firstVarRegex.exec(this.input);
      let result;
      let error;

      if (firstVarMatch) {
        const firstVar = firstVarMatch[2];

        try {
          result = new Function(this.input + ' return ' + firstVar)();
        } catch (e) {
          error = e;
        }
      } else {
        try {
          result = new Function('return ' + this.input)();
        } catch (e) {
          error = e;
        }
      }

      if (result !== undefined) 
      {
        this.data = result;
        this.type = this.registry.defs.describe(this.data);
        this.settings = this.registry.getTypeSettings(this.type);
      } 
      else if (error) 
      {
        sendNotification({ message: error });
      } 
      else 
      {
        sendNotification({ message: 'There was an unexpected problem detecting data.' });
      }
    },
    load() {
      const { type, data, settings } = this;

      if (type && this.isRemoveRestrictions) {
        type.removeDescribedRestrictions();
      }

      this.$emit('load', { type, data, settings });
    },
    onChange(event: TypeUpdateEvent) {
      this.type = event.type;
      this.settings = event.settings;
      
      if (event.transform) {
        const command = LiveRuntime.getCommand(event.transform);
        this.data = command({ value: this.data });
      }
    },
  },
});
